import React from 'react';
import { useIntl } from 'react-intl';
import { hasAssignments } from '@/shared/components/security/HasAssignments';
import messages from './FieldMessages';
import EnumChange from './EnumChange';
import FieldChange from './FieldChange';

import { getInvoiceStreamName } from './InvoiceStreamChange';

const InvoiceStreamPropertyChange = props => {
  const intl = useIntl();
  const {
    log,
    users,
    relations,
    ownCompanies,
    templates,
    invoiceSchedules,
    priceGrids,
    invoiceStreams,
  } = props;

  const isEnum = () => {
    const value = log.oldValue.Value || log.newValue.Value;
    return value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');
  };

  const displayLogLine = () => {
    const transformedLogLine = {
      ...log,
      oldValue: log.oldValue.Value,
      newValue: log.newValue.Value,
    };

    if (isEnum()) {
      return <EnumChange log={transformedLogLine} />;
    }

    return (
      <FieldChange
        log={transformedLogLine}
        users={users}
        relations={relations}
        ownCompanies={ownCompanies}
        templates={templates}
        invoiceSchedules={invoiceSchedules}
        priceGrids={priceGrids}
        invoiceStreams={invoiceStreams}
      />
    );
  };
  if (!hasAssignments()) return <span>{displayLogLine()}</span>;

  const invoiceStreamName = getInvoiceStreamName(log.oldValue ?? log.newValue, intl, '');

  return (
    <span>
      {displayLogLine()}
      &nbsp;
      {invoiceStreamName
        ? intl.formatMessage(messages.AssignmentWithDisplayValueProperty, {
            name: invoiceStreamName,
            b: value => <b>{value}</b>,
          })
        : intl.formatMessage(messages.DefaultAssignmentProperty)}
    </span>
  );
};

export default InvoiceStreamPropertyChange;
